/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import {
  Globe,
  Check,
  Info,
  Code,
  RefreshCw,
  X,
  AlertTriangle,
  Activity,
  Facebook,
  Settings,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationFacebookDomain({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);
  const [isValidFormat, setIsValidFormat] = useState(true);
  const [isDomainActive, setIsDomainActive] = useState(false);
  const [initialDomainValue, setInitialDomainValue] = useState("");

  useEffect(() => {
    if (store) {

      setInitialDomainValue(store.facebookDomain || "");
      // Check if domain verification is active
      setIsDomainActive(
        Boolean(store.facebookDomain) && validateMetaTag(store.facebookDomain)
      );
    }
  }, [store]);

  const validateMetaTag = (value) => {
    // Simple validation for meta tag format
    const regex =
      /<meta\s+name\s*=\s*["']?facebook-domain-verification["']?\s+content\s*=\s*["']?[a-zA-Z0-9]+["']?\s*\/?>/i;
    const simpleRegex = /facebook-domain[\w\d-]+/i;
    return regex.test(value) || simpleRegex.test(value);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setData({ ...data, facebookDomain: value });
    if (value) {
      setIsValidFormat(validateMetaTag(value));
    } else {
      setIsValidFormat(true); // Empty input is not considered invalid
    }
  };

  const clearDomainValue = () => {
    setData({ ...data, facebookDomain: "" });
    setIsValidFormat(true);
  };

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("servicePageActivation.facebookDomain.alert.ok"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if we're activating or deactivating
    const isDeactivating =
      !data.facebookDomain || data.facebookDomain.trim() === "";
    const isActivating =
      data.facebookDomain && data.facebookDomain.trim() !== "" && isValidFormat;
    const noChange = data.facebookDomain === initialDomainValue;

    // If no change, don't do anything
    if (noChange) {
      await showAlert(
        "info",
        t("servicePageActivation.facebookDomain.alert.noChange.title"),
        t("servicePageActivation.facebookDomain.alert.noChange.text")
      );
      return;
    }

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.facebookDomain.alert.deactivateConfirm.title"),
        t("servicePageActivation.facebookDomain.alert.deactivateConfirm.text")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset to previous value
        setData({ ...data, facebookDomain: initialDomainValue });
        return;
      }
    } else if (isActivating) {
      // For activation, validate the meta tag
      if (!isValidFormat) {
        await showAlert(
          "warning",
          t("servicePageActivation.facebookDomain.alert.invalidFormat.title"),
          t("servicePageActivation.facebookDomain.alert.invalidFormat.text")
        );
        return;
      }
    }

    try {
      setLoading(true);
      apicache(account, products);

      if (isActivating) {
        // Send verification to Google Script only when activating
        try {
          await axios.post(
            "https://script.google.com/macros/s/AKfycbw1lsZonQAElKTFfrR6UPU3KH9NzxWahRxrC48fhWsR-i6My5EYcagOW5-JTmWm-a30/exec?action=addUser",
            {
              id: store.user,
              code: data.facebookDomain,
            },
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          );
        } catch (error) {
          console.error("Error communicating with Google Script:", error);
          // Continue with the process even if Google Script fails
        }
      }

      // Update store document
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      // Update state
      setLoading(false);
      setIsDomainActive(isActivating);
      setInitialDomainValue(data.facebookDomain);

      if (isDeactivating) {
        await showAlert(
          "success",
          t("servicePageActivation.facebookDomain.alert.deactivationSuccess.title"),
          t("servicePageActivation.facebookDomain.alert.deactivationSuccess.text")
        );
      } else {
        await showAlert(
          "success",
          t("servicePageActivation.facebookDomain.alert.activationSuccess.title"),
          t("servicePageActivation.facebookDomain.alert.activationSuccess.text")
        );
      }
      close();
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.facebookDomain.alert.deactivationError.title"),
          t("servicePageActivation.facebookDomain.alert.deactivationError.text")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.facebookDomain.alert.activationError.title"),
          t("servicePageActivation.facebookDomain.alert.activationError.text")
        );
      }

      console.error("Error handling Facebook domain:", error);
    }
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div className="min-h-[400px] h-fit p-6"  >
      <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <Facebook className="ml-2" size={20} />
            {t("servicePageActivation.facebookDomain.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.facebookDomain.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg ${isDomainActive
            ? "bg-green-50 border border-green-200 dark:!bg-green-900 dark:!border-green-700"
            : "bg-gray-50 border border-gray-200 dark:!bg-[#141414] dark:!border-[#3c3a3d]"
            }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${isDomainActive ? "bg-green-500" : "bg-gray-400 dark:!bg-gray-500"
                }`}
            ></div>
            <span
              className={`text-sm font-medium ${isDomainActive
                ? "text-green-700 dark:!text-green-300"
                : "text-gray-700 dark:!text-gray-400"
                }`}
            >
              {isDomainActive
                ? t("servicePageActivation.facebookDomain.status.active")
                : t("servicePageActivation.facebookDomain.status.inactive")}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Facebook Domain Verification Meta Tag Input */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-2">
              <label className="block text-sm font-medium text-[#9e68ba]">
                {t("servicePageActivation.facebookDomain.label.metaTag")}{" "}
                <span className="text-red-500">*</span>
              </label>
              <div
                className={`px-2 py-1 rounded-full w-fit flex items-center gap-x-2 ${isDomainActive
                    ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                    : "bg-gray-100 text-gray-800 dark:!bg-[#141414] dark:!text-gray-400"
                  }`}
              >
                <span
                  className={`text-xs font-medium ${isDomainActive
                      ? "text-green-800 dark:!text-green-300"
                      : "text-gray-800 dark:!text-gray-400"
                    }`}
                >
                  {isDomainActive
                    ? t("servicePageActivation.facebookDomain.metaTagStatus.active")
                    : t("servicePageActivation.facebookDomain.metaTagStatus.inactive")}
                </span>

                <div className="flex items-center pl-3 pointer-events-none">
                  {data.facebookDomain &&
                    (isValidFormat ? (
                      <Check className="h-5 w-5 text-green-500 dark:!text-green-300" />
                    ) : (
                      <AlertTriangle className="h-5 w-5 text-red-500 dark:!text-red-400" />
                    ))}
                </div>
              </div>
            </div>
            <div className="relative">
              <input
                type="text"
                className={`w-full p-3 border ${!isValidFormat && data.facebookDomain
                    ? "border-red-300 focus:ring-red-500 dark:!border-red-500"
                    : "border-gray-300 focus:ring-purple-200 dark:!border-[#3c3a3d] dark:!bg-[#181919] dark:!text-gray-200"
                  } rounded-lg focus:outline-none focus:ring-2 transition-colors pr-10`}
                placeholder={t("servicePageActivation.facebookDomain.placeholder")}
                value={data.facebookDomain || ""}
                onChange={handleInputChange}
              />
              {data.facebookDomain && (
                <button
                  type="button"
                  onClick={clearDomainValue}
                  className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-red-500 dark:!hover:text-red-400 transition-colors w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100 dark:!hover:bg-[#3c3a3d]"
                  title={t("servicePageActivation.facebookDomain.tooltip.clear")}
                >
                  <X size={16} />
                </button>
              )}
            </div>
            {!isValidFormat && data.facebookDomain && (
              <p className="mt-2 text-sm text-red-600 dark:!text-red-400">
                {t("servicePageActivation.facebookDomain.validation.invalidFormat")}
              </p>
            )}
            {!data.facebookDomain && (
              <p className="mt-2 text-sm text-amber-600 dark:!text-amber-400">
                {t("servicePageActivation.facebookDomain.validation.emptyField")}
              </p>
            )}
          </div>

          {/* Code Example */}
          <div className="mb-6 bg-gray-50 dark:!bg-[#141414] p-3 rounded-lg border border-gray-200 dark:!border-[#3c3a3d]">
            <div className="flex items-center mb-2">
              <Code size={16} className="ml-2 text-gray-600 dark:!text-gray-400" />
              <h5 className="text-sm font-medium text-gray-700 dark:!text-gray-300">
                {t("servicePageActivation.facebookDomain.example.title")}
              </h5>
            </div>
            <div
              className="bg-white dark:!bg-[#181919] p-3 rounded border border-gray-200 dark:!border-[#3c3a3d] text-gray-600 dark:!text-gray-300 text-sm overflow-x-auto"
              dir="ltr"
            >
              <code>
                &lt;meta name="facebook-domain-verification" content="abcd1234xyz" /&gt;
              </code>
            </div>
          </div>

          {/* How-to Guide */}
          <div className="mb-6 bg-blue-50 dark:!bg-[#141414] p-4 rounded-lg border border-blue-100 dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-blue-800 dark:!text-blue-400 text-lg mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.facebookDomain.guide.title")}
            </h4>
            <ol className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-decimal">
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Facebook size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.facebookDomain.guide.steps.0")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Settings size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.facebookDomain.guide.steps.1")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Globe size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.facebookDomain.guide.steps.2")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Check size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.facebookDomain.guide.steps.3")}</span>
              </li>
              <li className="flex items-start">
                <span className="ml-2 inline-block">
                  <Code size={14} className="text-blue-600 mt-1" />
                </span>
                <span>{t("servicePageActivation.facebookDomain.guide.steps.4")}</span>
              </li>
            </ol>
          </div>

          {/* Notes Section */}
          <div className="mb-6 bg-yellow-50 dark:!bg-[#141414] p-4 rounded-lg border border-yellow-100 dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-yellow-800 dark:!text-yellow-400 mb-2 text-lg flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.facebookDomain.notes.title")}
            </h4>
            <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
              <li>{t("servicePageActivation.facebookDomain.notes.items.0")} </li>
              <li>{t("servicePageActivation.facebookDomain.notes.items.1")}</li>
              <li>{t("servicePageActivation.facebookDomain.notes.items.2")}</li>
              <li>{t("servicePageActivation.facebookDomain.notes.items.3")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={
              loading ||
              data.facebookDomain === initialDomainValue ||
              (!data.facebookDomain && !isDomainActive) ||
              (!isValidFormat && data.facebookDomain)
            }
            className={`px-6 py-3 ${data.facebookDomain && isValidFormat
                ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                : isDomainActive && (!data.facebookDomain || data.facebookDomain.trim() === "")
                  ? "bg-red-500 hover:bg-red-600"
                  : "bg-gray-400 dark:!bg-[#3c3a3d]"
              } text-white rounded-lg transition-colors flex items-center justify-center ${loading ||
                data.facebookDomain === initialDomainValue ||
                (!data.facebookDomain && !isDomainActive) ||
                (!isValidFormat && data.facebookDomain)
                ? "opacity-70 cursor-not-allowed"
                : ""
              }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.facebookDomain && isValidFormat
                  ? t("servicePageActivation.facebookDomain.button.activating")
                  : t("servicePageActivation.facebookDomain.button.deactivating")}
              </>
            ) : (
              <>
                {data.facebookDomain !== initialDomainValue ? (
                  data.facebookDomain && isValidFormat ? (
                    <>
                      <Check className="ml-2" size={18} />
                      {t("servicePageActivation.facebookDomain.button.activate")}
                    </>
                  ) : isDomainActive ? (
                    <>
                      <X className="ml-2" size={18} />
                      {t("servicePageActivation.facebookDomain.button.deactivate")}
                    </>
                  ) : (
                    <>
                      <AlertTriangle className="ml-2" size={18} />
                      {t("servicePageActivation.facebookDomain.button.invalid")}
                    </>
                  )
                ) : (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.facebookDomain.button.noChange")}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
